// /opt/ptg01-v1/front-extranet/lib/fetchExtranet.ts
// Helper fetch authentifié extranet — miroir de front-admin/lib/fetchAdmin.ts.
// Cookie httpOnly `nx_token` envoyé automatiquement via `credentials: 'include'`.
// Phase 2 C2 : plus besoin de localStorage token. Le cookie est géré par le browser.
//
// CSRF double-submit : le cookie `nx_csrf` (non-httpOnly) est lu en JS et renvoyé comme header
// `X-CSRF-Token`. Le backend valide que cookie === header sur les méthodes unsafe.
import type { ApiResponse } from '@nexvia/types';

function readCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]+)`));
    return match ? decodeURIComponent(match[1]) : null;
}

export async function fetchExtranet(url: string, options?: RequestInit): Promise<Response> {
    const csrf = readCookie('nx_csrf');
    const headers: Record<string, string> = {
        ...(options?.headers as Record<string, string> || {}),
    };
    if (csrf) headers['X-CSRF-Token'] = csrf;
    return fetch(url, {
        ...options,
        headers,
        credentials: 'include',   // 🔒 envoie le cookie httpOnly nx_token
    });
}

/**
 * Version typée qui parse directement la réponse JSON en ApiResponse<T>.
 * Usage :
 *   const res = await fetchExtranetJson<Consultant>('/api/me');
 *   if (res.success) { console.log(res.data) } else { console.error(res.message) }
 */
export async function fetchExtranetJson<T = unknown>(url: string, options?: RequestInit): Promise<ApiResponse<T>> {
    try {
        const res = await fetchExtranet(url, options);
        const json = (await res.json()) as ApiResponse<T>;
        return json;
    } catch (e) {
        return {
            success: false,
            message: e instanceof Error ? e.message : 'Erreur réseau',
            error: 'network',
        };
    }
}
